<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For Garfield, my son;</i></p>
<p class="ded1"><i>it’s not just the experiences but the lessons we take from them.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?c8c52886